// ============================================================
// SITE SETTINGS — edit contact details, links and images here.
// To replace a photo: drop your file into /public/images/ and
// change the `src` below (or overwrite the placeholder file with
// the same name). Set `placeholder: false` once it is your real photo.
// ============================================================

export const SITE = {
  name: "Alpha Transfer",
  tagline: "Private transfers & tours in Rhodes. Arrive in comfort. Explore in style.",
  phoneDisplay: "+30 694 5699689",
  phoneHref: "tel:+306945699689",
  whatsappNumber: "306945699689",
  email: "alphatransfer.rhodes@gmail.com",
  mhte: "1476E70000132200",
  instagram: "alphatransfer",
  instagramUrl: "https://www.instagram.com/alphatransfer",
  instagramDm: "https://ig.me/m/alphatransfer",
  mapEmbed: "https://www.google.com/maps?q=Rhodes%2C%20Greece&z=10&output=embed",
  logoLight: "/images/logo-mark-white.png",
  logoDark: "/images/logo-mark-black.png",
};

// Shows a small "Placeholder photo" tag on images marked placeholder: true.
export const SHOW_PLACEHOLDER_BADGES = true;

export const waLink = (text = "Hello Alpha Transfer, I would like to book a private transfer in Rhodes.") =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(text)}`;

const P = "/images/placeholders";
export const IMAGES = {
  hero: { src: "/images/hero-rhodes-view.jpg", alt: "Rhodes harbour and medieval castle at sunset", placeholder: false },
  airport: { src: `${P}/airport-arrivals.jpg`, alt: "Arrivals sign at the airport for Rhodes airport transfers", placeholder: true },
  anywhere: { src: `${P}/coastal-village.jpg`, alt: "Coastal village and road for private transfers anywhere in Rhodes", placeholder: true },
  tours: { src: `${P}/lindos-st-pauls-bay.jpg`, alt: "St Paul's Bay near Lindos, a highlight of Rhodes private tours", placeholder: true },
  vehicle: { src: "/images/vehicle-van.jpg", alt: "Black Mercedes private transfer van for up to 8 passengers in Rhodes", placeholder: false, contain: true },
  sedan: { src: `${P}/vehicle-sedan.jpg`, alt: "Private sedan for up to 4 passengers in Rhodes", placeholder: true },
  minibus: { src: "/images/vehicle-minibus.jpg", alt: "Black Mercedes private minibus for up to 12 passengers in Rhodes", placeholder: false, contain: true },
  interior: { src: `${P}/vehicle-interior.jpg`, alt: "Spacious leather seating inside the private transfer vehicle", placeholder: true },
  interior2: { src: `${P}/vehicle-interior-2.jpg`, alt: "Rear seating with luggage space in the private van", placeholder: true },
  coast: { src: `${P}/rhodes-coast-aerial.jpg`, alt: "Aerial view of the Rhodes coastline and turquoise sea", placeholder: true },
  bay: { src: `${P}/turquoise-bay.jpg`, alt: "Turquoise bay and sandy beach on Rhodes", placeholder: true },
  cliff: { src: `${P}/coast-cliff.jpg`, alt: "Cliffs above the Aegean Sea in Rhodes", placeholder: true },
  lindos: { src: `${P}/hero-lindos.jpg`, alt: "Lindos village and the Acropolis of Lindos above the bay", placeholder: true },
  butterflies: { src: `${P}/valley-butterflies.jpg`, alt: "Green valley and stream at the Valley of the Butterflies, Rhodes", placeholder: true },
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Transfers", to: "/transfers" },
  { label: "Tours", to: "/tours" },
  { label: "Contact", to: "/contact" },
];
